module.exports = __webpack_public_path__ + "icon_muutokset_ja_kriisitilanteet.72c35d8427e6d3d119d2.svg";